
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "deleteEmailTemplate",
      resolverType: "mutation",
      routePath: "/deleteEmailTemplate",
      httpMethod: "POST",
    });
  